import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import * as React from "react";
import { ReactNode } from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import { DialogCloseButton } from "./DialogCloseButton";

export function SimpleConfirmDialogButton({
  icon,
  label,
  dialogTitle,
  action,
  actionDisabled,
  dialogContent,
  variant = "outlined",
  color,
  disabled,
  onSuccess,
  onError,
}: {
  icon?: ReactNode;
  label: string;
  disabled?: boolean;
  dialogTitle: string;
  action: () => any;
  actionDisabled?: boolean;
  dialogContent?: ReactNode;
  variant?: "outlined" | "contained";
  color?: "primary" | "secondary" | "success" | "error" | "info" | "warning";
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
}) {
  if (disabled === undefined) disabled = false;
  if (actionDisabled === undefined) actionDisabled = false;

  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const onClose = () => setOpen(false);

  const actionWrapper = async () => {
    setLoading(true);
    let success = false;
    try {
      await action();
      success = true;
    } catch (error) {
      if (onError) {
        onError(error);
      } else {
        handleError("Aktion fehlgeschlagen.", error);
      }
    } finally {
      setLoading(false);
    }
    setOpen(false);
    if (success) {
      if (onSuccess) {
        onSuccess();
      } else {
        showSuccessToast("Aktion erfolgreich ausgeführt.");
      }
    }
  };
  const onClick = (e: any) => {
    e.stopPropagation();
    e.preventDefault();
    setOpen(true);
  };
  return (
    <>
      <Button variant={variant} color={color} startIcon={icon} disabled={disabled} onClick={onClick}>
        {label}
      </Button>
      <Dialog
        open={open}
        onClose={(_, __) => {
          // prevent closing the dialog when the action is still running
          if (loading) return;
          onClose();
        }}
      >
        <DialogTitle>{dialogTitle}</DialogTitle>
        <DialogCloseButton onClick={onClose} disabled={loading} />
        <DialogContent>{dialogContent}</DialogContent>
        <DialogActions>
          <LoadingButton
            variant="contained"
            color={color}
            onClick={actionWrapper}
            loading={loading}
            disabled={actionDisabled}
          >
            {`Jetzt ${label.toLowerCase()}`}
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
}
